<!--========= header start ==========-->
<header>
  <div class="topof-Header">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-md-4">
          <a routerLink="/" id="logo"><img src="./assets/images/mnk-logo.png" alt="Mallinckrodt Logo"> </a>
        </div>
        <div class="col-md-3">
          <form [formGroup]="SearchSiteForm">
            <div class="input-group rounded py-1">
              <span class="border-0 pt-1 pr-1" id="search-addon">
                <i class="fas fa-search iconclr"></i>
              </span>
              <input type="search" class="form-control rounded" formControlName="SearchText" placeholder="Search Site" aria-label="Search" aria-describedby="search-addon" (keyup.enter)="searchContent()" />
            </div>
          </form>
        </div>
        <div class="col-md-5">
          <ul class="pt-1">
            <li><a href="javascript:void(0)" (click)="openContactModal(template)">Contact Us</a></li>
            <li><a href="javascript:void(0)" (click)="OnNotProfileClick()">Logout</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="mainNav">
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <nav class="navbar navbar-expand-lg ">
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <i class="fas fa-bars"></i>
          </button>
          <a routerLink="/" id="logo-mbl"><img src="./assets/images/mnk-mbl-logo.png" alt="Mallinckrodt Logo"> </a>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mr-auto">
              <li class="nav-item" routerLinkActive="active"><a href="javscript:void(0);" class="nav-link" routerLink="home"><i class="fas fa-home"></i></a></li>
              <li class="nav-item" routerLinkActive="active"><a href="javscript:void(0);" class="nav-link" routerLink="about-us">About Us</a></li>
              <li class="nav-item" *ngIf="enabledMenuItems.isSMI && !isHomePage" routerLinkActive="active"><a class="nav-link" routerLink="find-medical-info">Search Medical Information</a></li>
              <li class="nav-item" *ngIf="enabledMenuItems.isRMI && !isHomePage" routerLinkActive="active"><a class="nav-link" routerLink="request-mi">Submit Medical Inquiry</a></li>
              <!-- <li class="nav-item" *ngIf="enabledMenuItems.isMSL" routerLinkActive="active"><a class="nav-link" routerLink="find-msl">Find My MSL</a></li>
              <li class="nav-item" *ngIf="enabledMenuItems.isAE" routerLinkActive="active"><a class="nav-link" routerLink="report-ae">Report an Adverse Event</a></li>
              <li class="nav-item" *ngIf="enabledMenuItems.isPC" routerLinkActive="active"><a class="nav-link" routerLink="report-pc">Report a Product Complaint</a></li>
              <li class="nav-item" *ngIf="enabledMenuItems.isNews" routerLinkActive="active"><a class="nav-link" routerLink="news-announcements">News and Announcements</a></li>
              <li class="nav-item" *ngIf="enabledMenuItems.isConferences" routerLinkActive="active"><a class="nav-link" routerLink="events-conferences">Events and Conferences</a></li> -->
              <li class="nav-item" *ngIf="enabledMenuItems.isProducts" routerLinkActive="active"><a class="nav-link" routerLink="our-products">Products</a></li>
              <li class="nav-item" *ngIf="enabledMenuItems.isPubs" routerLinkActive="active"><a href="javscript:void(0);" class="nav-link" routerLink="pubs">Publications</a></li>
              <li class="nav-item" *ngIf="enabledMenuItems.isResources" routerLinkActive="active"><a href="javscript:void(0);" class="nav-link" routerLink="resources">Resources</a></li>
              <li class="nav-item" *ngIf="enabledMenuItems.isFdbk" routerLinkActive="active"><a href="javscript:void(0);" class="nav-link" routerLink="fdbk">Feedback</a></li>
            </ul>
          </div>
        </nav>

        <!-- <ng-container *ngIf="enableLoginItems">
          <div class="dropdown useraccount" dropdown>
            <button *ngIf="!(LoginStatus$ | async) as LoginStatus" (click)="login()"
                    class="btn btn-secondary fs-14" type="button" id="dropdownMenuButton">
              <i *ngIf="LoginStatus" class="fas fa-user" title="Login"></i>&nbsp;Login
            </button>
            <span *ngIf="!(LoginStatus$ | async) as LoginStatus" class="text-white">&nbsp;|&nbsp;</span>
            <button (click)="register()" *ngIf="!(LoginStatus$ | async) as LoginStatus"
                    class="btn btn-secondary fs-14" type="button" id="dropdownMenuButton">
              <i class="" *ngIf="LoginStatus" title="Register"></i>Register
            </button>
            <button *ngIf="(LoginStatus$ | async) as LoginStatus" class="btn btn-secondary dropdown-toggle fs-14" type="button" id="dropdownMenuButton" dropdownToggle>
              <span *ngIf="UserFullName$ | async as UserFullName"> <i class="fas fa-user"></i> &nbsp;&nbsp;{{(UserFullName.length>8)? (UserFullName | slice:0:9)+'...':(UserFullName)}}</span>
            </button>
            <div *dropdownMenu class="dropdown-menu dropdown-menu-ovrd">
              <a class="dropdown-item" href="javascript:void(0)" routerLink="my-profile">My Profile</a>
              <a class="dropdown-item" href="javascript:void(0)" routerLink="my-requests">My Requests</a>
              <a class="dropdown-item" href="javascript:void(0)" (click)="logout()">Logout</a>
            </div>
          </div>
        </ng-container> -->

      </div>

    </div>
  </div>
</header>
<!--========= header end ==========-->

<ng-template #template>
  <div class="modal-header">
    <h5 class="modal-title w-100 d-block">
      Contact Us
      <span class="mt-1 float-right fs-13" data-dismiss="modal" (click)="modalRef?.hide()">
        <i class="fas fa-times pointer"></i>
      </span>
    </h5>
  </div>
  <div class="modal-body px-0">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 col-md-12">
          <ul class="contactUs">
            <li>
              <div class="row">
                <div class="col-md-12" *ngIf="isUS_Profile">
                  <p>
                    <span class="text-center"><i class="fas fa-phone-alt"></i></span>
                    <small>1-800-844-2830</small>
                  </p>
                  <p>
                    <small>Regular Office Hours: Monday to Friday 8:00 am - 5:30 pm ET</small>
                  </p>
                </div>

                <div class="col-md-12" *ngIf="!isUS_Profile">
                  <span class="text-center"><i class="fas fa-phone-alt"></i></span>
                  <small> Please locate your country-specific contact number <strong style="color: #7a8aca; cursor: pointer;" (click)="openContactDoc('Non-US_Contact_Details.docx', 'Mallinckrodt Contact Details')"> here. </strong> </small>
                </div>

                <div class="col-md-12 pt-2" *ngIf="enabledMenuItems.isRMI">
                  <span class="text-center"><i class="fas fa-file-medical"></i></span>
                  <a href="javascript:void(0)" class="d-block fs-13" (click)="navigateTo('/request-mi')"> Submit a Medical Inquiry </a>
                </div>
              </div>
            </li>

          </ul>
        </div>
      </div>
    </div>
  </div>
</ng-template>

